import { gql } from '@apollo/client';

const fetchProfileSponsors = gql`
  query fetchProfileSponsors($id: String!) {
    individual: getIndividual(id: $id) {
      resumeSponsorships(profileIndividualId: $id) {
        sponsoredBySomeone {
          membershipList {
            individualId
            isTerminated
            fullName
            type
          }
        }
      }
    }
  }
`;

export default fetchProfileSponsors;
